import Image from "next/image";
import { useEffect } from "react";

const Drawer = ({ title, open, onClose, children, size, position = "left" }) => {
  const positionClass =
    position === "right" ? "right-0 translate-x-full" : "left-0 -translate-x-full";
  const openClass = open ? "translate-x-0" : positionClass;

  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [open]);

  return (
    <div>
      {open && (
        <div
          className="bg-overlay fixed inset-0 z-30 backdrop-blur-xs transition-opacity duration-300"
          onClick={onClose}
          aria-hidden="true"
        />
      )}

      <div
        className={`fixed top-0 ${position === "right" ? "right-0" : "left-0"} h-screen p-4 transition-transform duration-300 ${size} ${openClass} z-40 overflow-y-auto bg-white`}
        tabIndex="-1"
        aria-labelledby="drawer-label"
      >
        <div className="mb-10 flex items-center pl-10">
          <Image
            src={title}
            id="drawer-label"
            alt="Drawer Title Image"
            className="h-auto w-3/5 max-w-[200px] sm:max-w-[300px] md:max-w-[400px] lg:max-w-[500px]"
            width={136}
            height={88}
            quality={85}
          />
        </div>

        <div>{children}</div>
      </div>
    </div>
  );
};

export default Drawer;
